
/* TST Upsell - Minimog Native Integration */
/* Only handles display and checkbox selection. */
/* Add to Cart is handled by Minimog ProductForm. */

(() => {
  if (window.__tstUpsellInitialized) return;
  window.__tstUpsellInitialized = true;

  function init(root = document) {
    root.querySelectorAll('[data-tst-upsell]').forEach((block) => {
      if (block.dataset.tstReady === 'true') return;

      block.dataset.tstReady = 'true';

      const rows = Array.from(
        block.querySelectorAll('[data-tst-upsell-item]')
      );

      const max = Math.max(
        1,
        Number(block.dataset.limit) || 1
      );

      let selected = rows;

      if (block.dataset.source === 'random') {
        selected = rows.slice();

        for (let i = selected.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));

          [selected[i], selected[j]] =
            [selected[j], selected[i]];
        }
      }

      const visible = new Set(selected.slice(0, max));

      rows.forEach((row) => {
        const show = visible.has(row);

        row.hidden = !show;

        const input = row.querySelector(
          'input[type="checkbox"]'
        );

        if (input) {
          input.disabled = !show;

          if (!show) {
            input.checked = false;
          }
        }
      });

      if (!visible.size) {
        block.hidden = true;
      }
    });
  }

  // Minimog ProductForm owns all cart submissions.
  // No separate submit listener is registered.

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => init()
    );
  } else {
    init();
  }

  document.addEventListener(
    'shopify:section:load',
    (event) => init(event.target)
  );
})();
